import { defineMessages } from 'react-intl-next';

const _default_1: {
	dismissButtonAria: {
		defaultMessage: string;
		description: string;
		id: string;
	};
} = defineMessages({
	dismissButtonAria: {
		id: 'growth-checklist.dismissButtonAria',
		defaultMessage: 'Dismiss {title}',
		description: 'Text for screen readers only to describe that this will dismiss the button.',
	},
});
export default _default_1;
